module.exports = __webpack_public_path__ + "media/images/login/icon_apple-9b22fee3dfc388b3778c8ca9a47bb0bc.png";